<template>
    <div class="description">
            <h3>{{ shortDesc }}</h3>
            <p>Data is from <a href="https://cryptocompare.com/" target="_blank" rel="noopener">CryptoCompare</a>, and is updated every 30 seconds.</p>
    </div>
</template>

<script>
export default {
    name: 'description',
    data: function() {
        return {
            shortDesc: 'A VueJS app for tracking crypto markets',
            longDesc: 'This website ranks the top 10 cryptocurrencies by market cap, allows you to easily compare cryptocurrency performance and rank over the last week.'
        }
    }
    }
</script>

<style lang="scss">
.description {
    max-width: 480px;
    margin: 0 auto;

    @media (max-width: 480px) {
        margin: 0 16px;
    }

    a {
        text-decoration: none;
        color: #6CA9EA;
    }
}

h1 {
    text-align: center;

    @media (max-width: 480px) {
        font-size: 1.5em;
    }
}

h3 {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Description.vue